import { Box, Card, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export const PlanCard = styled(Card)<{ isSelected: boolean }>(
  ({ isSelected }) => ({
    border: isSelected ? `1px solid #00B2A3` : "1px solid #E2E5F8",
    boxShadow: "none",
    borderRadius: "8px",
    maxWidth: "624px",
    padding: 24,
    backgroundColor: isSelected ? "#F5FFFE" : "none",

    ":hover": {
      border: `1px solid #00B2A3`
    }
  })
);

export const IconBox = styled(Box)<{ feature: boolean; isSelected: boolean }>(({
  feature,
  isSelected,
  theme
}) => {
  return {
    width: !feature ? 18 : 14,
    height: !feature ? 18 : 14,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    border: isSelected ? "1px solid #00B2A3" : "1px solid #D5D9E8",
    backgroundColor: isSelected ? "#00B2A3" : "#fff",
    [theme.breakpoints.up("sm")]: {
      width: !feature ? 22 : 14,
      height: !feature ? 22 : 14
    }
  };
});

export const RadioButtonChecked = styled(CheckIcon)({
  color: "#fff",
  zIndex: 2,
  width: "18px",
  backgroundColor: "#00B2A3",
  borderRadius: "50%"
});

export const PlanTitleBox = styled(Box)({
  display: "flex",
  alignItems: "center"
});

export const PlanTitle = styled(Box)(({ theme }) => ({
  color: "#1D1F2B",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  [theme.breakpoints.up("sm")]: {
    lineHeight: "23px",
    fontSize: "20px"
  }
}));

export const PlanPriceBox = styled(Box)({
  color: "#323946",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "15.6px",
  display: "flex",
  alignItems: "baseline",
  flexDirection: "column"
});

export const PlanPriceTextRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end"
});

export const PlanPriceText = styled(Box)({
  color: "#1D1F2B",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "15.8px",
  letterSpacing: "1%"
  // marginBottom: "8px",
});

export const PlanPrice = styled(Box)(({ theme }) => ({
  color: "#1D1F2B",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "16px",
  letterSpacing: "1%",
  [theme.breakpoints.up("sm")]: {
    fontSize: "40px",
    lineHeight: "46px"
  }
}));

export const PriceAdditionalInfoBox = styled(Box)({
  color: "rgba(0, 178, 163, 1)",
  fontWeight: 500,
  fontSize: "12px",
  textAlign: "right",
  width: "100%"
});

export const FeatureTitle = styled(Box)({
  color: "#1D1F2B",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "16.8px",
  marginBottom: 12
});

export const FeatureItem = styled(Box)({
  color: "#1D1F2B",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "13.8px"
});

export const TitlePriceWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 24,
  [theme.breakpoints.up("sm")]: {
    alignItems: "baseline"
  }
}));

export const PricingHelperText = styled(Box)({
  color: "#959EB2",
  fontWeight: 300,
  fontSize: "14px",
  lineHeight: "16.24px"
});
